import { render } from "./accessory.vue?vue&type=template&id=1d477b3c"
import script from "./accessory.vue?vue&type=script&lang=js"
export * from "./accessory.vue?vue&type=script&lang=js"

import "./accessory.vue?vue&type=style&index=0&id=1d477b3c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__